import { Component, Input, OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { hasTag, loadTags } from '../../util/tag-utils';
import { IConditionalSection } from '../../shared/models/condition-section.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar, MatCheckboxChange } from '@angular/material';
import { Tag } from '../../shared/models/tag.model';
import { BusinessTag } from '../models/business-tag.model';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { TagService } from '../../shared/services/tag.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';


@Component({
  selector: 'app-fuel-providers',
  templateUrl: './fuel-providers.component.html',
  styleUrls: ['./fuel-providers.component.scss']
})
export class FuelProvidersComponent implements OnInit, IConditionalSection {
  @Input() business: Business;
  fuelProviderTags: String[] = [];
  hasTag = hasTag;
  editModeSet = false;
  isRegionalManager = false;

  constructor(private _toggleService: EditToggleService,
              private _editFuelProvidersCheckboxDialog: MatDialog,
              private _businessManagerService: BusinessManagerService,
              private _tagService: TagService,
              public snackBar: MatSnackBar) {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  async ngOnInit() {
    this.loadAllTags();
    const allTags = await this._tagService.getAllTags();
    this.isRegionalManager = await this._businessManagerService.isRegionalManager()
      && !await this._businessManagerService.userOwnsBusiness(this.business.id);
  }

  loadAllTags() {
    this.fuelProviderTags = loadTags(this.business.tags, 'Fuel::Providers::', '', '');
  }

  get hasContent(): boolean {
    return this.fuelProviderTags.length > 0;
  }

  isChecked(tagId: number): boolean {
    const TAGS = this.business.tags;
    for (const tag of TAGS) {
      if (tag.tagId === tagId) {
        return true;
      }
    }
    return false;
  }

  async checkBoxChanged (event: MatCheckboxChange) {
    const ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
    const TAG_ID = +event.source.id;
    const BUSINESS_ID = this.business.id;
    try {
      if (event.source.checked) {
        await this._tagService.postTag(TAG_ID, BUSINESS_ID);
      } else {
        await this._tagService.deleteTag(TAG_ID, BUSINESS_ID);
      }
      const newBusiness = await this._businessManagerService.updateBusiness(this.business);
      Object.assign(this.business, newBusiness);
    } catch (e) {
      this.snackBar.open(ERROR_MSG, 'Error', {
        duration: 6000
      });
      throw e;
    }
  }

  openEditRentalsDialog(group: String[], except: String[], title: string): void {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      business: this.business,
      tagsGroup: group,
      except: except,
      title: title
    };

    dialogConfig.width = '95%';
    const dialogRef = this._editFuelProvidersCheckboxDialog.open(EditTagsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isSuccess) => {
      if (isSuccess) {
        this.loadAllTags();
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
